import React, { Fragment, FunctionComponent, useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import "./verifyOtp.scss"
import "../../constants/_global.scss"
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import TextInput from '../../components/textInput/textInput';
import { useSelector, useDispatch } from "react-redux";
import { CONFIRM, ENTER_OTP, INCORRECT_OTP, RESEND_OTP } from '../../constants/messages';
import { IErrorResponseType } from '../../constants/commonTypes';
import Loader from '../../components/loader/loader';
import { APP_URLS, BACKSPACE_KEYCODE, DELETE_KEYCODE, OTP_EXHAUSTED, OTP_LENGTH} from '../../constants/constants';
import { ProfileDetailsState } from '../../core/reducers/profileDetailsReducer';
import { OtpState } from '../../core/reducers/otpReducer';
import { getTransactionIdFromURL, padStart } from '../../constants/utils';
import { SuccessState } from '../../core/reducers/successReducer';
import { OTP_PAGELOAD_PARAM, OTP_CONFIRM , pushDataLayer, RESEND_OTP_GA, OTP_PAGELOAD_VPV } from '../../constants/gaConstants';
import { AuthState } from '../../core/reducers/authReducer';
//import TextField from '@mui/material/TextField';
import OtpInput from 'react-otp-input';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';

interface IVerifyOtpProps {
  profileDetails: ProfileDetailsState;
  arcApproveDetails: SuccessState;
  otpDetails: OtpState;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: IErrorResponseType;
  partnerData: AuthState;
  generateOtp: () => void;
  verifyOtp: (req: object) => void;
  submitARCApprove: () => void;
  getAumMobileDetails: () => void;
  transactionDetails: TransactionState;
}

const VerifyOtp: FunctionComponent<IVerifyOtpProps> = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    otpDetails,
    profileDetails,
    isAuthenticated,
    error,
    arcApproveDetails,
    partnerData,
    submitARCApprove,
    generateOtp,
    verifyOtp,
    getAumMobileDetails,
    transactionDetails,
  } = props;
  const [otp, setOtp] = useState("")
  const otpRef = useRef<HTMLInputElement>(null)
  //const otpRefArr = useRef<any[]>([useRef(null),useRef(null),useRef(null),useRef(null),useRef(null),useRef(null)])
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(1)
  const [resendOtp, setResendOtp] = useState(true)
  const [canProceed, setCanProceed] = useState(false)
  const [isMyInputFocused, setIsMyInputFocused] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false)
  const history = useHistory();
  const txnId = getTransactionIdFromURL()
  const OTPLENGTH = new Array(OTP_LENGTH).fill(0)

  const handleChange = (otp) => { 
      setOtp(otp )
  }

  const updateTime = () => {
    if (minutes === 0 && seconds === 0) {
      setResendOtp(false)
    }
    else {
      if (seconds === 0) {
        setMinutes(minutes => minutes - 1);
        setSeconds(59);
      } else {
        setSeconds(seconds => seconds - 1);
      }
    }
  }


  // GA on page load
  useEffect(() => {
    pushDataLayer(OTP_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    pushDataLayer(OTP_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
  }, [])

  // GA on incorrect OTP
  useEffect(() => {
    if (otpVerified && !otpDetails.isValid && otpDetails.attemptsLeft !== -1) {
    }
  }, [otpVerified, otpDetails.isValid, otpDetails.attemptsLeft])


  useEffect(() => {
    if (isAuthenticated && profileDetails.aumMobile === "") {
      getAumMobileDetails();
    }
  }, [profileDetails, isAuthenticated, getAumMobileDetails])

  useEffect(() => {
    if (arcApproveDetails.transactionStatus !== "" && arcApproveDetails.validVintage == 'Yes') {
      history.push(`${APP_URLS.SUCCESS.replace(":txnId", txnId)}`);
    }
    else if(arcApproveDetails.transactionStatus !== "" && arcApproveDetails.validVintage == 'No'){
      history.push(`${APP_URLS.VERIFY_SUCCESS.replace(":txnId", txnId)}`);
    }
  }, [arcApproveDetails, history, txnId])

  useEffect(() => {
    if (error) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: { errorCode: error.code }
      })
    }
  }, [error, history, txnId])

  useEffect(() => {
    if (otpVerified && !otpDetails.isValid && otpDetails.attemptsLeft === 0) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: { 
          errorCode: OTP_EXHAUSTED,
          partnerName: partnerData.partnerName !== "" ? partnerData.partnerName : null
        }
      })
    }
  }, [otpVerified, otpDetails, history, txnId, partnerData])

  useEffect(() => {
    if (isAuthenticated && profileDetails.aumMobile !== "") {
      generateOtp();
    }
  }, [isAuthenticated, profileDetails, generateOtp])

  useEffect(() => {
    if (otpDetails.referenceId === "") return;

    const token = setTimeout(updateTime, 1000)

    return function cleanUp() {
      clearTimeout(token);
    }
  })

  useEffect(() => {
    if (otp.length === OTP_LENGTH) {
      setCanProceed(true)
    } else {
      setCanProceed(false)
    }
  }, [otp])

  const handleResendOtp = () => {
    if (isAuthenticated) {
      pushDataLayer(RESEND_OTP_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      generateOtp();
      setOtp("")
      setSeconds(0);
      setMinutes(1);
      setResendOtp(true)
      if (otpRef.current) {
        otpRef.current.focus()
      }
    }
  }

  const handleSubmit = () => {
    if (isAuthenticated) {
      pushDataLayer(OTP_CONFIRM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      let req = {
        referenceId: otpDetails.referenceId,
        code: otp
      }
      setOtpVerified(true)
      verifyOtp(req)
      if (otpRef.current) {
        otpRef.current.focus()
      }
    } else {
      setOtpVerified(false)
    }
    setOtp("")
  }

  useEffect(() => {
    if (otpVerified && otpDetails.isValid) {
      submitARCApprove();
    }
  }, [otpDetails, otpVerified, submitARCApprove])
  
  
  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className="otp-container">
        <div className="otp-wrapper">
          <Text fontWeight={700} className="heading">{ENTER_OTP}</Text>
          <Text className="sub-heading">An <b>OTP</b> has been sent to you on your mobile number <b>{profileDetails.aumMobile}</b></Text>
          <div className="otp-input-container">
            <OtpInput
              className="otp-input-blocks"
              value={otp}
              onChange={handleChange}
              numInputs={6}
              //separator={<span style={{ width: "20px" }}></span>}
              shouldAutoFocus={true}
              isInputNum={true}
              isInputSecure={true}
              focusStyle={{
                boxShadow: "0 2px 20px #ed116429",
                outline: "none"
              }}
            />
          </div>
          {
            (otpVerified && !otpDetails.isValid && otpDetails.attemptsLeft !== -1) &&
            <div className="error-text-wrapper">
              <Text className={"error-text"}>
                {INCORRECT_OTP(otpDetails.attemptsLeft)}
              </Text>
            </div>
          }
          <div className="resend-otp">
            <Text>{padStart(minutes, 2)}:{padStart(seconds, 2)}</Text>
            <AxisButton disabled={resendOtp} onClick={handleResendOtp} customStyle={"hyperlink-btn"}>
              <Text className={"hyperlink-btn-text"}>{RESEND_OTP}</Text>
            </AxisButton>
          </div>
          <div className="submit-btn-container btn-mob">
            <AxisButton onClick={handleSubmit} disabled={!canProceed} disableElevation customStyle={"submit-btn-primary"} variant="contained">
              <Text className={"submit-btn-text"}>{CONFIRM}</Text>
            </AxisButton>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default VerifyOtp;
